export const cottonRag = {
    title: '100% Cotton Rag',
    description: 'Our high end lightly textured fine art paper is made from 100% cotton rag and weighing 320gsm ensures that it is highly robust and handles mounting well. The paper offers strong reproduction of blacks and good colour intensity. If you are looking for that fine art reproduction, this is a great option.',
    rows: [
        { label: 'Max Print Size', value: '44 x 470'},
        { label: 'Weight (GSM)', value: '320'},
        { label: 'Finish', value: 'Matt'},
        { label: 'Texture', value: 'Light Texture'},
        { label: 'Paper Tone', value: 'Warm White'},
    ]
}

export const semiGloss = {
    title: 'Semi Gloss Photo Paper',
    description: 'Chosen for its photographic aesthetics, vibrant colour reproduction, high contrast and robust feel. Semi gloss is the go-to choice for photography printing as it provides the colour vibrancy without the same high levels of reflectivity that you get with a normal glossy photo paper',
    rows: [
        { label: 'Max Print Size', value: '44 x 470'},
        { label: 'Weight (GSM)', value: '240'},
        { label: 'Finish', value: 'Semi Gloss'},
        { label: 'Texture', value: 'Smooth'},
        { label: 'Paper Tone', value: 'Bright White'},
    ]
}

export const smoothMatt = {
    title: 'Smooth Matt Paper',
    description: 'Our most popular everyday matt paper provides excellent print output at a reasonable price point. This paper is perfect for printing posters, prints and photographs where the desired finish is matt.',
    rows: [
        { label: 'Max Print Size', value: '44 x 470'},
        { label: 'Weight (GSM)', value: '230'},
        { label: 'Finish', value: 'Matt'},
        { label: 'Texture', value: 'Smooth'},
        { label: 'Paper Tone', value: 'Bright White'},
    ]
}


// WEBPACK FOOTER //
// ./src/page/art-printing/section-text.js